import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { ROUTES } from "./pages/routes";
import { AppLayout } from "./components/layout/AppLayout";

const USER_INFO_KEY = "user_info";

export const isAuthenticated = (): boolean => {
  const userData = JSON.parse(localStorage.getItem(USER_INFO_KEY) || "{}");
  return Boolean(userData.token);
};

interface RouteProps {
  children: React.ReactNode;
  redirectTo: string;
}

export const ProtectedRoute: React.FC<RouteProps> = ({
  children,
  redirectTo,
}) => {
  if (!isAuthenticated()) return <Navigate to={redirectTo} />;
  return <>{children}</>;
};

export const PrivateRoute: React.FC<RouteProps> = ({
  children,
  redirectTo,
}) => {
  if (isAuthenticated()) return <Navigate to={redirectTo} />;
  return <>{children}</>;
};

const Routing: React.FC = () => (
  <Routes>
    {ROUTES.map(
      ({ path, component: Component, isProtected, redirectTo, useShell }, index) => (
        <Route
          key={index}
          path={path}
          element={
            isProtected ? (
              <ProtectedRoute redirectTo={redirectTo}>
                {useShell ? (
                  <AppLayout>
                    <Component />
                  </AppLayout>
                ) : (
                  <Component />
                )}
              </ProtectedRoute>
            ) : (
              <PrivateRoute redirectTo={redirectTo}>
                <Component />
              </PrivateRoute>
            )
          }
        />
      )
    )}
    <Route path="*" element={<Navigate to="/login" replace />} />
  </Routes>
);

export default Routing;
